var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DialogLayout',{attrs:{"title":"資料未儲存，確定離開頁面？","openDialog":_vm.showDialog,"maxWidth":500,"btnAlign":"center","enableCancel":"","cardContentClass":"px-3 pt-8 pb-4"},on:{"close":_vm._dialogAction}},[_vm._v("資料未儲存，操作將被作廢")])}
var staticRenderFns = []

export { render, staticRenderFns }